import { LinkListsElementSchema } from '../../content/schema/pageElements.val';

interface LinksElementProps {
  lists: LinkListsElementSchema['lists'];
}

const LinkListsElement: React.FC<LinksElementProps> = ({ lists }) => {
  return (
    <div className="flex gap-64 gap-x-24 flex-col tablet:flex-row laptop:px-128">
      {lists.map((list, listIndex) => {
        return (
          <div key={`${listIndex}${list.title}`} className="w-full space-y-16">
            <h3 className="text-2xl tablet:text-3xl">{list.title}</h3>
            <ul className="space-y-8 tablet:space-y-12 text-lg tablet:text-xl">
              {list.items.map((item, itemIndex) => {
                return <li key={`${itemIndex}${item.text}`}>{item.text}</li>;
              })}
            </ul>
          </div>
        );
      })}
    </div>
  );
};

export default LinkListsElement;
